import { Component } from '@angular/core';

@Component({
  selector: 'mst-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
}
